// extracted by css-extract-rspack-plugin
export default {"root":"root-IuN2wL","details":"details-SR1Nd2","editor":"editor-RSmECe","subBlock":"subBlock-CMGxat","errors":"errors-SxCZoZ subBlock-CMGxat"};